import Team from './team';
import './team.scss';

export default Team;